module.exports = __webpack_public_path__ + "img/red-fail-title1.7eb61b24.png";